<div class="article-type-attributes">
  <sc-padding>
    @for (group of getNonDeletedAttributeGroups(); track group) {
      <div>
        <app-dictionary-entry-label [model]="group.name"></app-dictionary-entry-label>
        <button mat-icon-button (click)="editAttributeGroup(group)">
          <sc-action-icon iconClass="fa-pencil"></sc-action-icon>
        </button>
        <button mat-icon-button (click)="removeAttributeGroup(group)">
          <sc-action-icon iconClass="fa-trash"></sc-action-icon>
        </button>
      </div>
      <table class="table">
        @for (attribute of getNonDeletedAttributes(group); track attribute; let i = $index) {
          <tr>
            <td class="text-selection column-index">{{i+1}}</td>
            <td class="text-selection column-type">
              @if (attribute.type === 'STRING') {
                <sc-icon iconClass="fa-input-text" matTooltip="STRING"></sc-icon>
              }
              @if (attribute.type === 'TEXT') {
                <sc-icon iconClass="fa-text" matTooltip="TEXT"></sc-icon>
              }
              @if (attribute.type === 'NUMBER') {
                <sc-icon iconClass="fa-input-numeric" matTooltip="NUMBER"></sc-icon>
              }
              @if (attribute.type === 'DECIMAL') {
                <sc-icon iconClass="fa-input-numeric" matTooltip="DECIMAL"></sc-icon>
              }
              @if (attribute.type === 'BOOLEAN') {
                <sc-icon iconClass="fa-square-check" matTooltip="BOOLEAN"></sc-icon>
              }
              @if (attribute.type === 'DATE') {
                <sc-icon iconClass="fa-calendar" matTooltip="DATE"></sc-icon>
              }
              @if (attribute.type === 'LOOKUP') {
                <sc-icon iconClass="fa-ballot-check" matTooltip="LOOKUP"></sc-icon>
              }
            </td>
            <td class="text-selection column-name">
              <div>
                <span [ngClass]="{ 'mandatory': attribute.mandatory }">
                  <app-dictionary-entry-label [model]="attribute.name"></app-dictionary-entry-label>
                </span>
                @if (attribute.mandatory) {
                  <span>*</span>
                }
              </div>
              @if (attribute.type === 'LOOKUP') {
                <div style="font-style: italic;">
                  @for (value of attribute.values; track value; let i = $index) {
                    @if (value.deleted === false) {
                      <span>
                        @if (i > 0) {
                          <span>, </span>
                          }{{value.value}}
                        </span>
                      }
                    }
                  </div>
                }
              </td>
              <td class="column-action">
                <button mat-icon-button (click)="editAttribute(attribute, group)">
                  <sc-action-icon iconClass="fa-pencil"></sc-action-icon>
                </button>
                <button mat-icon-button (click)="removeAttribute(attribute, group)">
                  <sc-action-icon iconClass="fa-trash"></sc-action-icon>
                </button>
              </td>
            </tr>
          }
        </table>
      }
    </sc-padding>
  </div>
